(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rpt-language', {
            parent: 'entity',
            url: '/rpt-language',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'RptLanguages'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-language/rpt-languages.html',
                    controller: 'RptLanguageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('rpt-language-detail', {
            parent: 'entity',
            url: '/rpt-language/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'RptLanguage'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-language/rpt-language-detail.html',
                    controller: 'RptLanguageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RptLanguage', function($stateParams, RptLanguage) {
                    return RptLanguage.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rpt-language',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rpt-language-detail.edit', {
            parent: 'rpt-language-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-language/rpt-language-dialog.html',
                    controller: 'RptLanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RptLanguage', function(RptLanguage) {
                            return RptLanguage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rpt-language.new', {
            parent: 'rpt-language',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-language/rpt-language-dialog.html',
                    controller: 'RptLanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rpt-language', null, { reload: 'rpt-language' });
                }, function() {
                    $state.go('rpt-language');
                });
            }]
        })
        .state('rpt-language.edit', {
            parent: 'rpt-language',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-language/rpt-language-dialog.html',
                    controller: 'RptLanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RptLanguage', function(RptLanguage) {
                            return RptLanguage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-language', null, { reload: 'rpt-language' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rpt-language.delete', {
            parent: 'rpt-language',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-language/rpt-language-delete-dialog.html',
                    controller: 'RptLanguageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RptLanguage', function(RptLanguage) {
                            return RptLanguage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-language', null, { reload: 'rpt-language' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
